import { render, staticRenderFns } from "./TranslateScreen.vue?vue&type=template&id=9e39552a&"
import script from "./TranslateScreen.vue?vue&type=script&lang=js&"
export * from "./TranslateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports